/* src/app/modules/home/components/show-more/show-more.component.scss */
.flu-details {
  min-height: 50%;
  position: relative;
}
.flu-details__img {
  max-height: 43.75rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.flu-details__text {
  padding: 0.7rem 3%;
}
.flu-details__title {
  font-size: 1.5rem;
  font-weight: var(--font-weight-book);
  line-height: 2;
}
.flu-details ods-button {
  position: absolute;
  top: 0;
  right: 0;
}
:host ::ng-deep .popup-container {
  max-width: 50rem !important;
}
/*# sourceMappingURL=show-more.component.css.map */
